import * as React from "react";

interface PlusIconProps {
    className?: string;
    onClick?: () => void;
}

export class PlusIcon extends React.Component<PlusIconProps> {
    render(){
        return (
          <div {...this.props} data-testid="plus-icon" style={{ filter: "none", boxShadow: "none" }}>
            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 5.5H8.5V1C8.5 0.447812 8.05219 0 7.5 0H6.5C5.94781 0 5.5 0.447812 5.5 1V5.5H1C0.447812 5.5 0 5.94781 0 6.5V7.5C0 8.05219 0.447812 8.5 1 8.5H5.5V13C5.5 13.5522 5.94781 14 6.5 14H7.5C8.05219 14 8.5 13.5522 8.5 13V8.5H13C13.5522 8.5 14 8.05219 14 7.5V6.5C14 5.94781 13.5522 5.5 13 5.5Z" />
            </svg>
           </div>
        );
    }
}
